/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Republish_Check_RequiredInputs */

const vi_einvoice_republish_check_required = /** @type {(inputs: Einvoice_Republish_Check_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãy tích ô xác nhận sau khi kiểm tra trên web MISA.`)
};

/**

* @param {Einvoice_Republish_Check_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_republish_check_required = /** @type {((inputs?: Einvoice_Republish_Check_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Republish_Check_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_republish_check_required(inputs)
});